import { MapView } from "@/components/Map";
import { useEffect, useState } from "react";
import { Link } from "wouter";

interface CityLocation {
  name: string;
  slug: string;
  lat: number;
  lng: number;
}

const cities: CityLocation[] = [
  { name: "Santa Barbara", slug: "santa-barbara", lat: 34.4208, lng: -119.6982 },
  { name: "Ventura", slug: "ventura", lat: 34.2746, lng: -119.2290 },
  { name: "Montecito", slug: "montecito", lat: 34.4369, lng: -119.6376 },
  { name: "Goleta", slug: "goleta", lat: 34.4358, lng: -119.8276 },
  { name: "Carpinteria", slug: "carpinteria", lat: 34.3988, lng: -119.5185 },
  { name: "Ojai", slug: "ojai", lat: 34.4480, lng: -119.2429 },
  { name: "Camarillo", slug: "camarillo", lat: 34.2164, lng: -119.0376 },
  { name: "Solvang", slug: "solvang", lat: 34.5958, lng: -120.1376 },
  { name: "Buellton", slug: "buellton", lat: 34.6138, lng: -120.1926 },
  { name: "Santa Ynez", slug: "santa-ynez", lat: 34.6141, lng: -120.0818 },
  { name: "Isla Vista", slug: "isla-vista", lat: 34.4133, lng: -119.8610 },
  { name: "Summerland", slug: "summerland", lat: 34.4214, lng: -119.5965 },
  { name: "Oxnard", slug: "oxnard", lat: 34.1975, lng: -119.1771 },
  { name: "Los Angeles", slug: "los-angeles", lat: 34.0522, lng: -118.2437 },
];

export default function ServiceAreaMap() {
  const [selectedCity, setSelectedCity] = useState<string | null>(null);

  const handleMapReady = async (map: google.maps.Map) => {
    // Import AdvancedMarkerElement library
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    // Add markers for each city
    cities.forEach((city) => {
      // Create custom pin
      const pin = new PinElement({
        background: "#1e3a8a",
        borderColor: "#ffffff",
        glyphColor: "#ffffff",
        scale: 1.2,
      });

      // Create advanced marker
      const marker = new AdvancedMarkerElement({
        map: map,
        position: { lat: city.lat, lng: city.lng },
        title: city.name,
        content: pin.element,
      });

      // Create info window
      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div style="padding: 8px; font-family: system-ui, -apple-system, sans-serif;">
            <h3 style="margin: 0 0 8px 0; font-size: 16px; font-weight: 600; color: #1e3a8a;">${city.name}</h3>
            <p style="margin: 0 0 8px 0; font-size: 14px; color: #4b5563;">Professional painting & waterproofing services</p>
            <a href="/city/${city.slug}" style="display: inline-block; padding: 6px 12px; background: #1e3a8a; color: white; text-decoration: none; border-radius: 4px; font-size: 14px; font-weight: 500;">View Services</a>
          </div>
        `,
      });

      // Add click listener to marker
      marker.addListener("click", () => {
        setSelectedCity(city.name);
        infoWindow.open(map, marker);
      });

      // Hover effect
      marker.addListener("mouseenter", () => {
        pin.background = "#0066cc";
        pin.scale = 1.4;
      });

      marker.addListener("mouseleave", () => {
        pin.background = "#1e3a8a";
        pin.scale = 1.2;
      });
    });

    // Set map bounds to include all cities
    const bounds = new google.maps.LatLngBounds();
    cities.forEach((city) => {
      bounds.extend({ lat: city.lat, lng: city.lng });
    });
    map.fitBounds(bounds);
    
    // Add some padding to the bounds
    const padding = { top: 50, right: 50, bottom: 50, left: 50 };
    map.fitBounds(bounds, padding);
  };

  return (
    <div className="w-full">
      <div className="container px-4 py-16">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a8a] mb-4">
            Our Service Area Map
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Click on any city marker to learn more about our services in that area
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="rounded-lg overflow-hidden shadow-lg border border-gray-200" style={{ height: "500px" }}>
            <MapView
              onMapReady={handleMapReady}
              className="w-full h-full"
              initialCenter={{ lat: 34.4208, lng: -119.6982 }}
              initialZoom={10}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
